import { ADD_HOST_CATEGORIES_FORM_NAME } from "./shared";

import React from "react";
import { connect } from "react-redux";

import { Button, FontIcon } from "react-md";

import { setActiveForm } from "../../../actions/appActions";

import Translate from "../../Translation";

import {DebugElement} from "../../debug";

import {HostCategories_Add_and_Edit_AsRedux} from "./HostCategories_Add_and_Edit";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../../../AtollonTheme/ReactElements";

const HostCategoriesHeaderAsReact = ( inputProps ) => {

    let {
        setActiveForm,
        HostCategories_id,
        state
    } = inputProps;

    if( state.app && state.app.form )
    {
        let {
            app: {
                role,
                form: {
                    activeForm
                }
            }
        } = state;

        let isAdding = activeForm === ADD_HOST_CATEGORIES_FORM_NAME;
        let isEditing = HostCategories_id;

        return (
            <div>
                <TouchPageHeader
                    title={'Kategorie hostitelů'}
                    buttons={
                        isAdding || isEditing
                            ? (
                                <div/>
                            )
                            : (
                                <div>
                                    <Button
                                        raised
                                        className="btn btn-primary touchButton-1"
                                        label="Přidat kategorii"
                                        onClick={() => setActiveForm( ADD_HOST_CATEGORIES_FORM_NAME )}
                                    >
                                        <FontIcon className="color-white">album</FontIcon>
                                    </Button>
                                </div>
                            )
                    }
                    debugText={"HostCategoriesHeader.js"}
                />
                <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
            </div>
        );
    }
    else
    {
        return null;
    }
};

export const HostCategoriesHeaderAsRedux = connect(
    state => {return {state}},
    { setActiveForm }
)( HostCategoriesHeaderAsReact );



// WEBPACK FOOTER //
// ./src/Atollon/pages/HostCategories/HostCategoriesHeader.js